var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector55(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 309,
    viewBox: "0 0 75 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.244 307.546C304.856 288.631 301.149 284.512 286.333 265.103C282.703 260.348 276.991 251.104 271.536 239.687C269.901 236.27 268.419 232.882 267.06 229.541C257.366 205.634 255.998 178.851 258.25 152.4C264 84.911 227.468 23.9991 172.157 6.24177C116.751 -11.544 55.2243 17.7161 25.2024 63.3764C21.2964 69.3176 4.06639 97.3535 1.51942 128.113C-6.54915 225.233 87.5271 264.04 230.67 293.424C233.455 293.993 246.713 296.167 249.526 296.556L328.253 307.556L328.244 307.546Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector55);
export default __webpack_public_path__ + "static/media/vector5-5.2415746efe32b230fccc25777e39bde9.svg";
export { ForwardRef as ReactComponent };